import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=68440712&"
import script from "./AddBrand.vue?vue&type=script&lang=js&"
export * from "./AddBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports